import { useCallback, useEffect, useState } from "react";

/** Local edits layered on cached server data — survives React Query cache hits on remount. */
export function useServerDraft<T>(serverValue: T | undefined | null, resetKey?: string | number) {
  const [override, setOverride] = useState<T | null>(null);

  useEffect(() => {
    setOverride(null);
  }, [resetKey]);

  const value = (override ?? serverValue ?? null) as T | null;

  const setValue = useCallback(
    (next: T | ((prev: T) => T)) => {
      setOverride((prev) => {
        const base = (prev ?? serverValue) as T;
        return typeof next === "function" ? (next as (prev: T) => T)(base) : next;
      });
    },
    [serverValue],
  );

  const reset = useCallback(() => setOverride(null), []);

  return {
    value,
    setValue,
    reset,
    isDirty: override !== null,
  };
}
